import * as React from 'react';
import styled from '@independent-software/typeui/styles/Theme'

import { Button } from '@independent-software/typeui/controls/Button'
import { Icon } from '@independent-software/typeui/controls/Icon'
import { Panel } from '@independent-software/typeui/controls/Panel'
import { Gravatar } from '@independent-software/typeui/controls/Gravatar'

import { AuthContext } from '../AuthContext';

interface IProps {
  /** @ignore */
  className?: string;
}

const CurrentUserBase = (props: IProps) => {
  const auth = React.useContext(AuthContext);

  const [open, setOpen] = React.useState(false);

  const handleUserClick = () => setOpen(!open);

  const handleClose = () => setOpen(false);

  // Sign out via Keycloak (ends the SSO session and redirects to hosted login).
  const handleSignout = () => {
    setOpen(false);
    auth.signout();
  }

  // Manage account via Keycloak's hosted account console.
  const handleAccount = () => {
    setOpen(false);
    auth.accountManagement();
  }

  return (
    <div className={props.className}>
      {auth != null && 
        <React.Fragment>
          <Gravatar email={auth.email} onClick={handleUserClick}/>
          <Panel open={open} onClose={handleClose} padded>
            <UserData>
              <Gravatar size="tiny" email={auth.email}/>
              <div>
                <Line><Icon name="id-card" color="#ccc"/> <Username>{auth.name}</Username></Line>
                <Line><Icon name="envelope" color="#ccc"/> {auth.email}</Line>
              </div>
            </UserData>
            <Buttons>
              <Button negative onClick={handleSignout}>Sign out</Button>
              <Button onClick={handleAccount}>Manage account</Button>
            </Buttons>
          </Panel>
        </React.Fragment>}
    </div>
  );
}

const Username = styled.div`
  font-weight: 500;
`

const UserData = styled.div`
  display: flex;
  align-items: flex-start;
  white-space: nowrap;
  margin-bottom: 10px;
  & > *:first-child {
    margin-right: 10px;
  }
`

const Line = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  svg {
    margin-right: 8px;
  }
`

const Buttons = styled.div`
  white-space: nowrap;
`

const CurrentUser = styled(CurrentUserBase)`
  position: relative;
  display: inline-block;  
`

export { CurrentUser }
